// AUD-04 B19 — one shortcut hint per platform.
//
// A Mac keyboard says ⌘K; Windows and Linux say Ctrl K. Every hint chip in the app
// takes its text from here, so one rule decides it and no screen types ⌘ or Ctrl by
// hand. Labels only: the listeners (App.js, and the components Conv #169 names)
// already accept metaKey OR ctrlKey and are not touched by this file.
//
// Pure apart from one optional read of `navigator`. With no navigator (a Node test,
// a server render) the answer is Ctrl, never a throw.

// userAgentData.platform says "macOS"; navigator.platform says "MacIntel"; the user
// agent says "Macintosh". iPhone and iPad keyboards use ⌘ too.
const APPLE = /mac|iphone|ipad|ipod/i;

function currentNavigator() {
  return typeof navigator !== 'undefined' ? navigator : null;
}

// true when the keyboard in front of the user has a ⌘ key.
export function isMacPlatform(nav = currentNavigator()) {
  if (!nav) return false;
  const platform = (nav.userAgentData && nav.userAgentData.platform) || nav.platform || nav.userAgent || '';
  return APPLE.test(String(platform));
}

// The modifier on its own: '⌘' on a Mac, 'Ctrl' everywhere else.
export function modKeyLabel(nav = currentNavigator()) {
  return isMacPlatform(nav) ? '⌘' : 'Ctrl';
}

// The hint for modifier + key: shortcutLabel('K') → '⌘K' on a Mac, 'Ctrl K' elsewhere.
export function shortcutLabel(key, nav = currentNavigator()) {
  const k = String(key == null ? '' : key).toUpperCase();
  return isMacPlatform(nav) ? `⌘${k}` : `Ctrl ${k}`;
}
